import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNotificationServiceTypeListQueryVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
}>;


export type GetNotificationServiceTypeListQuery = { __typename?: 'Query', pushNotificationServiceTypeList: Array<{ __typename?: 'PushNotificationServiceTypeResult', serviceTypeId: string, serviceTypeName: string }> };


export const GetNotificationServiceTypeListDocument = gql`
    query GetNotificationServiceTypeList($market: String!) {
  pushNotificationServiceTypeList(market: $market) {
    serviceTypeId
    serviceTypeName
  }
}
    `;

/**
 * __useGetNotificationServiceTypeListQuery__
 *
 * To run a query within a React component, call `useGetNotificationServiceTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationServiceTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationServiceTypeListQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetNotificationServiceTypeListQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationServiceTypeListQuery, GetNotificationServiceTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationServiceTypeListQuery, GetNotificationServiceTypeListQueryVariables>(GetNotificationServiceTypeListDocument, options);
      }
export function useGetNotificationServiceTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationServiceTypeListQuery, GetNotificationServiceTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationServiceTypeListQuery, GetNotificationServiceTypeListQueryVariables>(GetNotificationServiceTypeListDocument, options);
        }
export type GetNotificationServiceTypeListQueryHookResult = ReturnType<typeof useGetNotificationServiceTypeListQuery>;
export type GetNotificationServiceTypeListLazyQueryHookResult = ReturnType<typeof useGetNotificationServiceTypeListLazyQuery>;
export type GetNotificationServiceTypeListQueryResult = Apollo.QueryResult<GetNotificationServiceTypeListQuery, GetNotificationServiceTypeListQueryVariables>;